import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthz } from '@ohpen/react-authz';

import { getPortalSections } from './sideBarItems';

/**
 * The portal is named after the sections the account can reach, so a broker-only account never reads "Product".
 * Undefined until permissions and flags have loaded, because the empty sets before then would name every account
 * after the product side.
 */
export const usePortalName = (): string | undefined => {
  const { t } = useTranslation();
  const { userPermissions, envFeatureFlags, isLoading } = useAuthz();

  return useMemo(() => {
    if (isLoading) return undefined;
    const { brokers, products } = getPortalSections(userPermissions, envFeatureFlags);
    if (brokers && products) return t('global.portalNames.brokersAndProducts');
    if (brokers) return t('global.portalNames.brokers');
    return t('global.portalNames.products');
  }, [envFeatureFlags, isLoading, t, userPermissions]);
};
